<template>
	<div class="home">
		<div class="top">
			<van-popup v-model="show"  get-container="body" :style="{ height: '85%',width: '90%' }"  :closeable="true">
				<div class="">
					<div class="plr20 bggrey  ft28" style="height: 6vh; line-height: 6vh;">申请人信息</div>
					<van-cell-group class="plr20">
						<van-cell title="申请人" :value="showForm.roposerName" />
						<van-cell title="申请人电话" :value="showForm.roposerPhone" />
						<van-cell title="申请人公司类型" :value="showForm.proposerType==1?'工程公司':'矿属单位'" />
						<van-cell v-if="showForm.proposerType==1" title="公司名称" :value="showForm.roposerCompany" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">审批者信息</div>
					<van-cell-group class="plr20">
						<van-cell title="审批者" :value="showForm.approverName" />
						<van-cell title="审批者电话" :value="showForm.approverPhone" />
						<!-- <van-cell v-if="showForm.confirmTime" title="离矿时间" :value="showForm.confirmTime" /> -->
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">报备信息</div>
					<van-cell-group class="plr20">
						<van-cell title="出矿时间" :value="showForm.leaveTime " />
						<van-cell title="出矿地点" :value="showForm.leaveLocName" />
						<van-cell title="车牌号" :value="showForm.truckNo" />
						<van-cell title="出矿事由" :value="showForm.leaveReason" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">出矿物资</div>
					<div v-for="(item, index) in showForm.goodsList" :key="index">
						<div class="bgwhite yellow2 ft30 pl30 bor-bt" style="height: 5.5vh; line-height: 5.5vh;">
							物资{{ index + 1 }}</div>
						<van-cell-group class="plr20">
							<van-cell title="物资名称" :value="item.goodsName" />
							<van-cell title="物资规格" :value="item.goodsModel" />
							<van-cell title="物资数量" :value="item.goodsCount" />
							<div class="flex alstart between mt20">
								<span class="ft30 w40">物资照片</span>
								<template v-if="item.goodsPhone.indexOf(',')!=-1">
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" v-for="(i,v) in item.goodsPhone.split(',')" :key="v"
											:src="i"  @click="imagePreview(item,v,1)" style="display: flex; word-wrap: break-word; word-break: normal;padding: 0 1vw 1vw 0; ">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
								<template v-else>
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" :src="item.goodsPhone"  @click="imagePreview(item,0,1)" style="padding: 0 1vw 1vw 0; ">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
							</div>
						</van-cell-group>
					</div>
					<div class="tc ptb10">
						<van-button type="danger" class="tc" @click="show=false">关闭</van-button>
					</div>
				</div>
			</van-popup>
			
			<div class="homes">
				<van-tabs v-model="active" @click="initContent" color="#4597ff">
					<van-tab title="当前报备">
						<div >
							<van-popup v-model="nishow" get-container="#app" round position="center" :style="{ height: '70%',width: '90%' }" :close-on-click-overlay="false">
								<div class="m30 relative">
									<div class="ft30 bold ptb20 tc fixed w90" style="position: fixed !important;">
										<div class="tc">
											入厂人员安全告知
										</div>
									</div>
									<div class="ptb20 tc" style="height: 20px;">
									</div>
									<div class="ft28">
										<div class="">
											各位领导、客户及来访者，欢迎光临我司检查、参观、联系业务。为保证大家的人身健康与安全，请配合公司熟悉并遵守如下规定：
										</div>
										<div class="mt10">
											1、进入公司前请在公司值班室配合保安人员进行必要登记及出示相关证件。进入厂区、库区的所有车辆请按照限速标志行驶，并按照指定地点停放。严禁酒后进入公司。
										</div>
										<div class="mt10">
											2、请在指定地点（办公室或休息室吸烟点）吸烟，烟头要丢在烟灰缸内，厂区内禁止流动吸烟。
										</div>
										<div class="mt10">
											3、严禁携带易燃、易爆和其他危险化学品进入公司厂区、库区，进入库区人员请在库区入口处交出火种。
										</div>
										<div class="mt10">
											4、如需将公司物资带出厂，请主动出示《物资放行申请单》。
										</div>
										<div class="mt10">
											5、严禁私自进入生产区域，如需进入生产现场，请在公司陪同人员引导下沿指定的安全路线行走；进入生产现场，应遵守各种安全警示标志的提示，佩戴必要的劳动防护用品，做好个人防护。
										</div>
										<div class="mt10">
											6、公司配有医务室，如有身体不适，可立即联系身边的陪同人员。参观期间，如有火灾、地震等突发情况，您可就近拿取附件的救援物资使用。撤离时，请您听从陪同人员的引导，按照疏散指示有序撤离。
										</div>
										<div class="mt10">
											请您认真阅读安全告知，衷心感谢您的配合！
										</div>
										<div class="tc mt30">
											<van-tag type="success" size="large" @click="nishow=false">我已知晓</van-tag>
										</div>
									</div>
									
								</div>
							</van-popup>
							<div class="modals bggrey" >
								<van-form ref="appForm" @submit="onSubmit"  @failed="failed" validate-trigger="onSubmit" label-align="center" :scroll-to-error="true" :validate-first="true">
										<div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
											申请人信息
										</div>
										<van-field v-model="appForm.roposerName " name="申请人" label="申请人" placeholder="请输入申请人姓名"
											:required="true" :rules="[{ required: true, message: '请填写申请人姓名' }]" />
										<van-field v-model="appForm.roposerPhone " name="申请人电话" label="申请人电话" placeholder="请输入申请人电话"
											:required="true" :rules="[{ required: true, message: '请填写申请人电话' }]" />
										<van-field v-model="proposerType"  @click="openPicker1('CType')" label="公司类型" placeholder="请选择公司类型"
											:required="true" :rules="[{ required: true, message: '请选择公司类型' }]" />
										<van-field v-if="appForm.proposerType==1" v-model="appForm.roposerCompany" name="公司名称" label="公司名称" placeholder="请输入公司名称"
											:required="true" :rules="[{ required: true, message: '请填写公司名称' }]" />
										<div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
											审批者信息
										</div>
										<div class="" v-for="item,index1 in appForm.goodsCheckerList" :key="index1+1">
											<div class="bgwhite yellow2 pl30 bor-bt ft28 flex between" style="height: 6.5vh !important; line-height: 6.5vh;">
												<span>审批者{{index1+1}}</span>
												<span class="red w30 tc" v-if="appForm.goodsCheckerList.length>1" @click="delApprover(index1,item)">删除审批者</span>
											</div>
											<van-field v-model="item.checkerName" name="审批者" label="审批者" placeholder="请输入审批者姓名"
												:required="true" :rules="[{ required: true, message: '请填写审批者姓名' }]" />
											<van-field v-model="item.checkerPhone" name="审批者电话" label="审批者电话" placeholder="非必填,请输入审批者电话"
												>
												<!-- <template #button>
														<van-button size="small" type="primary" native-type="button" @click="checkPhone(item)">校验</van-button>
												</template> -->
											</van-field>
											<div v-if="appForm.proposerType==2" class="bor-top bgwhite flex between tc ft28" style="height: 6vh !important; line-height: 6vh;">
												<span class="blue w50" @click="addApprover" >+添加审批者</span>
											</div>
										</div>
										<div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
											报备信息
										</div>
										<van-field readonly clickable name="calendar" :value="appForm.leaveTime" label="出矿时间" :required="true"
											placeholder="点击选择时间" @click="openPicker(1)" :rules="[{ required: true, message: '请选择出矿时间' }]" />
										<van-field v-model="leaveLoc"  @click="openPicker1('C06')" label="出矿地点" placeholder="请选择出矿地点"
											:required="true" :rules="[{ required: true, message: '请选择出矿地点' }]" />
										<van-field v-model="appForm.truckNo" name="车牌号" label="车牌号" placeholder="请输入车牌号"
											:required="true" :rules="[{ required: true, message: '请选择出矿地点' }]" />
										<van-field v-model="appForm.leaveReason" name="出矿事由" label="出矿事由" placeholder="请输入出矿事由"
											:required="true" :rules="[{ required: true, message: '请填写出矿事由' }]" />
										<div id="screen">
											<van-popup v-model="showCalendar" get-container="#screen" round position="bottom" :safe-area-inset-bottom="true">
												<van-datetime-picker
													 v-if="showCalendar"
													 v-model="currentDate"
													 type="datetime"
													 title="选择时间"
													 item-height="7vh"
													 :min-date="minDate"
													 :max-date="maxDate"
													@confirm="onConfirm"
													@cancel="cancel"
												/>
											</van-popup>
											<van-popup v-model="showPicker" round position="bottom" get-container="#screen">
												<van-picker title="请选择" show-toolbar item-height="7vh" :columns="columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
											</van-popup>
										</div>
										
										<div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
											出矿物资
										</div>
										<div class="" v-for="item,index in appForm.goodsList" :key="index">
											<div class="bgwhite yellow2 pl30 bor-bt ft28 flex between" style="height: 6.5vh !important; line-height: 6.5vh;">
												<span>物资{{index+1}}</span>
												<span class="red w30 tc" v-if="appForm.goodsList.length>1" @click="delVis(index,item)">删除物资</span>
											</div>
											<van-field v-model="item.goodsName" name="物资名称" label="物资名称" placeholder="请输入物资名称"
												:required="true" :rules="[{ required: true, message: '请填写物资名称' }]" />
											<van-field v-model="item.goodsModel" name="物资规格" label="物资规格" placeholder="请输入物资规格"
												:required="true" :rules="[{ required: true, message: '请填写物资规格' }]" />
											<van-field v-model="item.goodsCount" name="物资数量" label="物资数量" placeholder="请输入物资数量"
												:required="true" :rules="[{ required: true, message: '请填写物资数量' }]" />
											<van-field name="uploader" label="物资照片" :required="true" :rules="[{ required: true, message: '请上传物资照片' }]" >
											<template #input>
												<van-uploader :name="1+','+index" :after-read="afterRead" :multiple="true"  v-model="item.goodsPhoneList" />
											</template>
											</van-field>
											<div class="bor-top bgwhite flex between tc ft28" style="height: 6.5vh !important; line-height: 6.5vh;">
												<span class="blue w50" @click="addVis">+添加物资</span>
											</div>
										</div>
										
										<div style="position: fixed;bottom: 0;" class="flex w100">
											<van-button class="flex1 w47" style="border-right: 3px solid #fff" square @click="reset"  block type="info" native-type="button">重置</van-button>
											<van-button class="flex1 w50" square  block type="info" native-type="submit">提交</van-button>
										</div>
									</van-form>
								
							</div>
						</div>
					</van-tab>
					<van-tab title="报备历史">
						<div >
							<van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
								<div class="autoFixed">
									<van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
										<van-cell v-for="(item, index) in historyList" :key="index"
											style="margin-top: 20px; padding: 0">
											<div class="main">
												<div class="history-left" style="margin-top: 20px;">
													<div class="history-item">
														<span>审核者：</span>
														<span>{{ item.approverName }}</span>
													</div>
													<div class="history-item">
														<span>审核者手机号：</span>
														<span>{{ item.approverPhone }}</span>
													</div>
													<div class="history-item">
														<span>出矿事由：</span>
														<span>{{ item.leaveReason }}</span>
													</div>
													<div class="history-item">
														<span>出矿时间：</span>
														<span>{{ item.leaveTime }}</span>
													</div>
													<div class="history-item">
														<span> 申请人： </span>
														<span>{{ item.roposerName }}</span>
													</div>
													<div class="history-item">
														<span>申请人电话：</span>
														<span>{{ item.roposerPhone }}</span>
													</div>
												</div>
												<div class="hisotry-right">
													<img v-if="item.checkStatus==0" src="@/assets/visitor/daishenhe.png"
														alt="" />
													<img v-if="item.checkStatus == 1" src="@/assets/visitor/agree.png"
														alt="" />
													<img v-if="item.checkStatus == 2" src="@/assets/visitor/reject.png"
														alt="" />
													<img class="quxiao" v-if="item.checkStatus == 9" src="@/assets/sushe/quxiao.png"
														alt="" />
												</div>
												<van-button plain type="info" size="small" class="userBtn"
													@click="cancleApp(item)" v-if="item.checkStatus==0">取消
												</van-button>
												<van-button plain type="primary" size="small" class="userBtn1"
													@click="getDetail(item)">详情
												</van-button>
												<van-button plain type="info" size="small" class="userBtn2"
													@click="goAgain(item)">重新预约
												</van-button>
											</div>
										</van-cell>
									</van-list>
								</div>
							</van-pull-refresh>
						</div>
					</van-tab>
				</van-tabs>
			</div>
			
		</div>
	</div>
</template>
<script>
	import tabs from "@/components/tabs.vue";
	import {
		tbGoodsReportAdd,
		tbGoodsReportHistory,
		tbGoodsReportCancel,
		registerCheck,
		userCheck,
		uploadImg,
		tbGoodsReportGetSysCategory
	} from "@/apis/api";
	import {
		Toast,
		Dialog,
		ImagePreview,
	} from "vant";
	import {
		formatTime1
	} from "@/utils/index";
	export default {
		data() {
			return {
				historyList: [],
				pageNo:1,
				pageSize:10,
				total:0,
				isLoading: false,
				loading: false,
				finishedBottom: false,
				active: 0,
				list: [{
						name: "当前报备",
						type: "current",
					},
					{
						name: "报备历史",
						type: "history",
					},
				],
				minDate: new Date(2022, 1, 1),
				maxDate: new Date(2028, 10, 1),
				currentDate: new Date(),
				showForm:{},
				healthCodeList:[],
				appForm: {
					approverName:'',
					approverPhone:'',
					goodsCheckerList:[
						{
							checkerName: "",
							checkerPhone: "",
						}
					],
					goodsList: [
						{
							goodsCount: "",
							goodsModel: "",
							goodsName: "",
							goodsPhone: "",
							goodsPhoneList: [],
						}
					],
					leaveLoc: "",
					leaveReason: "",
					leaveTime: "",
					openId: "",
					proposerType: 1,
					roposerCompany: "",
					roposerName: "",
					roposerPhone: "",
					truckNo: "",
				},
				leaveLoc:'',
				proposerType:'',
				picker_car:'',
				show: false,
				nishow: false,
				showPicker: false,
				showCalendar: false,
				columns:[],
				picker_v: 1,
			};
		},
		mounted() {
			document.title = "物资出矿";
			this.nishow = true;
		},
		methods: {
			// 打开picker弹窗
			openPicker1(code) {
				if(this.picker_car != code)
				this.getSysCategory(code);
				this.picker_car = code
				this.showPicker = true;
			},
			// picker弹窗确定
			pickerConfirm(e){
				if(this.picker_car=="C06"){
					console.log(e);
					this.appForm.leaveLoc=e.id;
					this.leaveLoc=e.name;
				}else if(this.picker_car=="CType"){
					this.appForm.proposerType=e.value;
					if(e.value==2){
						this.appForm.roposerCompany = '';
						this.roposeCheckPhone();
					}
					console.log(this.appForm.proposerType);
					this.proposerType = e.text;
				}
				this.showPicker = false;
			},
			roposeCheckPhone(item){
				let registerCheckModel = {
					name : this.appForm.roposerName,
					phone: this.appForm.roposerPhone,
				}
				userCheck(registerCheckModel).then((res) => {
					if(res.code==200){
						// this.$toast('校验通过');
					}else{
						this.$toast('申请人信息不属于矿属单位,请选择工程公司'); 
					}
				});
			},
			pickerCancel(){
				this.showPicker = false;
			},
			// 获取picker数据
			getSysCategory(code,keyWord=''){
				if(code=='CType'){
					this.columns=[{
						text:'工程公司',
						value:1
					},
					{
						text:'矿属单位',
						value:2
					}]
				}else{
					let data={
						code,keyWord
					}
					tbGoodsReportGetSysCategory(data).then((res) => {
						if(res.code==200){
							if(res.result.length){
								res.result.forEach((i,v)=>{
									i.text = i.name
								})
							}
							this.columns = res.result;
						}else{
							this.$toast(res.message);
						}
					});
				}
			},
			imagePreview(item,list,index){
				var images,arr;
				if(index==1){
					if(item.goodsPhone.indexOf(',')!=-1){
						arr = item.goodsPhone.split(',');
						images = arr;
					}else{
						images = [item.goodsPhone]
					}
				}
				console.log(images);
				ImagePreview({
				  images,
				  startPosition: list,
					closeable: true,
				});
			},
			// 预约详情
			getDetail(item){
				this.show = true;
				this.showForm = item;
			},
			// 重新预约
			goAgain(item){
				this.appForm.approverName = item.approverName;
				this.appForm.approverPhone = item.approverPhone;
				this.appForm.leaveTime = item.leaveTime;
				this.appForm.leaveLoc = item.leaveLoc;
				this.leaveLoc = item.leaveLocName;
				this.appForm.leaveReason = item.leaveReason;
				this.appForm.proposerType = item.proposerType;
				if(item.proposerType==1){
					this.proposerType = '工程公司';
				}else{
					this.proposerType = '矿属单位';
				}
				this.appForm.openId = item.openId;
				this.appForm.roposerCompany = item.roposerCompany;
				this.appForm.roposerName = item.roposerName;
				this.appForm.roposerPhone = item.roposerPhone;
				this.appForm.truckNo = item.truckNo;
				this.appForm.goodsList = item.goodsList;
				this.appForm.goodsList.forEach((items,index)=>{
					this.$set(this.appForm.goodsList[index],'goodsPhone','')
					this.$set(this.appForm.goodsList[index],'goodsPhoneList',[])
				})
				this.appForm.goodsCheckerList = [];
				item.goodsCheckerList.forEach((items,index)=>{
					this.appForm.goodsCheckerList.push({
						'checkerName':items.checkerName,
						'checkerPhone':items.checkerPhone
					})
				})
				this.initContent(0)
			},
			// 添加审核者
			addApprover(){
				this.appForm.goodsCheckerList.push({
					approverName: "",
					approverPhone: "",
				})
			},
			// 删除审核者
			delApprover(index,item){
				Dialog({ message: "提示" });
				Dialog.confirm({
					title: "提示",
					message: `确认删除审核者${index+1}吗？`,
				}).then(() => {
					if(this.appForm.goodsCheckerList.length>1){
						this.appForm.goodsCheckerList.splice(index,1)
					}
				}).catch(() => {
				});
			},
			// 添加物资
			addVis(){
				this.appForm.goodsList.push({
					goodsCount: "",
					goodsModel: "",
					goodsName: "",
					goodsPhone: "",
					goodsPhoneList: [],
				})
			},
			// 删除物资
			delVis(index,item){
				Dialog({ message: "提示" });
				Dialog.confirm({
					title: "提示",
					message: `确认删除物资${index+1}吗？`,
				}).then(() => {
					if(this.appForm.goodsList.length>1){
						this.appForm.goodsList.splice(index,1)
					}
				}).catch(() => {
				});
			},
			// 选日期弹窗
			openPicker(picker_v) {
				this.picker_v = picker_v;
				this.showCalendar = true;
			},
			// 选日期弹窗
			onConfirm(date) {
				console.log(date);
				console.log(formatTime1('hm',date));
				this.appForm.leaveTime = formatTime1('hm',date);
				this.showCalendar = false;
			},
			cancel(){
				this.showCalendar = false;
			},
			checkPhone(item){
				let registerCheckModel = {
					name : item.checkerName,
					phone: item.checkerPhone,
				}
				registerCheck(registerCheckModel).then((res) => {
					if(res.code==200){
						this.$toast('校验通过');
					}else{
						this.$toast(res.message); 
					}
				});
			},
			// 文件上传
			afterRead(file,params) {
				console.log(file);
				console.log(params);
				let index = params.name.split(',')[1];
				if(Array.isArray(file)){
					for(let i =0;i<file.length;i++){
						file[i].file.status = 'uploading';
						file[i].file.message = '上传中...';
						uploadImg({
							img: file[i].content,
							openId: localStorage.getItem('openId'),
							ext: file[i].file.name.split('.')[1]
						}).then(res => {
							Toast('上传成功')
							this.appForm.goodsList[index].goodsPhone +=(','+res.result.savePath);
							file[i].file.status = 'done';
							file[i].file.message = '上传成功';
						})
					}
				}else{
					file.status = 'uploading';
					file.message = '上传中...';
					uploadImg({
						img: file.content,
						openId: localStorage.getItem('openId'),
						ext: file.file.name.split('.')[1]
					}).then(res => {
						Toast('上传成功')
						this.appForm.goodsList[index].goodsPhone +=(','+res.result.savePath);
						file.status = 'done';
						file.message = '上传成功';
						
					})
				}
			},
			// 重置
			reset(){
				this.appForm = {
					approverName: "",
					approverPhone: "",
					goodsCheckerList:[
						{
							checkerName: "",
							checkerPhone: "",
						}
					],
					goodsList: [
						{
							goodsCount: '',
							goodsModel: "",
							goodsName: "",
							goodsPhone: "",
							goodsPhoneList: [],
						}
					],
					leaveLoc: "",
					leaveReason: "",
					leaveTime: "",
					openId: "",
					proposerType: 1,
					roposerCompany: "",
					roposerName: "",
					roposerPhone: "",
					truckNo: "",
				}
				this.leaveLoc='';
				this.proposerType='';
			},
			// 校验失败
			failed(){
				console.log(111);
			},
			// 提交预约
			onSubmit() {
				this.appForm.openId = localStorage.getItem('openId') || '';
				let arr = this.appForm.goodsList;
				this.appForm.goodsList = [];
				arr.forEach((i,v)=>{
					this.appForm.goodsList.push({
						goodsCount: i.goodsCount,
						goodsModel: i.goodsModel,
						goodsName: i.goodsName,
						goodsPhone:i.goodsPhone.slice(0,1)==','?i.goodsPhone.slice(1):i.goodsPhone,
					})
				})
				this.appForm.approverName = this.appForm.goodsCheckerList[0].checkerName;
				this.appForm.approverPhone = this.appForm.goodsCheckerList[0].checkerPhone;
				console.log(this.appForm);
				tbGoodsReportAdd(this.appForm).then((res) => {
					if(res.code==200){
						this.$toast(res.message);
						this.reset();
					}else{
						this.$toast(res.message);
					} 
				});
			},
			// 获取历史
			getHistoryList() {
				this.onRefresh(1)
			},
			onRefresh(index) {
				this.pageNo = 1;
				this.pageSize = 10;
				this.isLoading = true;
				tbGoodsReportHistory({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						if(index!=1){
							Toast("刷新成功");
						}
						this.historyList = res.result.records;
						this.total = res.result.total;
						if (this.historyList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			onLoad() {
				console.log("加载更多");
				if(this.isLoading)return
				this.pageNo++;
				apptHistory({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						this.historyList = this.historyList.concat(res.result.records);
						if (this.historyList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			// 取消预约
			cancleApp(item){
				Dialog({
					message: "提示"
				});
				Dialog.confirm({
					title: "提示",
					message: "确认取消吗？",
				})
				.then(() => {
					tbGoodsReportCancel({
						id: item.id,
					}).then((res) => {
						if(res.code==200){
							Toast(res.message);
							this.getHistoryList()
						}else{
							Toast(res.message);
						}
					});
				})
				.catch(() => {
				});
			},
			
			
			initContent(value) {
				this.active = value;
				if (value == 0) {
					// 刷新页面
				} else {
					this.pageSize = 10;
					this.pageNo = 1;
					this.getHistoryList();
				}
			},
			
		},
		components: {
			tabs,
		},
	};
</script>

<style lang="less" scoped>
	body{
	   height:100%;
	}
	.homes {
		border-top: 1px solid #ccc;
		width: 100%;
		height:100%;
	}
	.modals {
		position: relative;
		height: 100%;
		padding-bottom:7vh !important;
		
	}
	.autoFixed {
		background: #f3f3f3;
		min-height: 100vh;
		padding:0 20px;
		position: relative;
		.userBtn {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #4597FF;
		}
		.userBtn1 {
			position: absolute;
			right: 20px;
			top: 85px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #55aa7f;
		}
		.userBtn2 {
			position: absolute;
			right: 20px;
			top: 150px;
			width: 134px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #4597ff;
		}
	
		.main {
			box-sizing: content-box;
			background: #ffffff;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			width: 100%;
			border-radius: 5px;
			padding:0 24px;
			box-sizing: border-box;
			position: relative;
			.roomName {
				position: absolute;
				left: 20px;
				top: 20px;
				color: #64b0ff;
				font-weight: bold;
			}
	
			.hisotry-right {
				img {
					width: 150px;
					height: 150px;
				}
				.quxiao{
					width: 150px;
					height: 130px;
				}
			}
	
			.history-item {
				margin-bottom: 15px;
	
				span {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}
	// /deep/.van-picker-column__item{
	// 	height: 84px !important;
	// }
</style>
